import React from 'react';

import { Wrapper } from './Block.jsx';
import Comment from './Comment.jsx';
import Name from '../utility/Name.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function SocialComponent(props) {
    let content, contentStyle, innerStyle, wrapperStyle;
    let horizontalSpacing = 28;
    let iconAlignment = 'center';
    const contentContainerStyle = { borderCollapse: 'separate', maxWidth: '100%', minWidth: '100%' };
    if (props.blockConfig) {
        const iconProps = { iconAlignment: 'center', paddingLeft: `${horizontalSpacing / 2}px`, paddingRight: `${horizontalSpacing / 2}px` };
        if (props.blockConfig.block) {
            wrapperStyle = {};
            Utilities.mapStyleConfigProps(contentContainerStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'backgroundColor':
                        wrapperStyle = { backgroundColor: propValue };
                        return true;
                    case 'contentColor':
                        contentContainerStyle.backgroundColor = propValue;
                        return true;
                    case 'horizontalSpacing':
                        horizontalSpacing = propValue;
                        return true;
                    case 'iconSize':
                    case 'verticalSpacing':
                        iconProps[propName] = { unit: propUnit, value: propValue };
                        return true;
                    case 'iconAlignment':
                        iconAlignment = propValue;
                    // Intentional fallthrough
                    case 'iconStyle':
                        iconProps[propName] = propValue;
                        return true;
                }
            });
        }
        const _horizontalSpacing = parseInt(horizontalSpacing, 10);
        if (!isNaN(_horizontalSpacing)) {
            switch (iconProps.iconAlignment) {
                case 'left':
                    iconProps.paddingLeft = undefined;
                    iconProps.paddingRight = `${_horizontalSpacing}px`;
                    break;
                case 'right':
                    iconProps.paddingLeft = `${_horizontalSpacing}px`;
                    iconProps.paddingRight = undefined;
                    break;
                default:
                    iconProps.paddingLeft = `${_horizontalSpacing / 2}px`;
                    iconProps.paddingRight = `${_horizontalSpacing / 2}px`;
                    break;
            }
        }
        if (props.blockConfig.layout) {
            contentStyle = {};
            innerStyle = {};
            Utilities.mapStyleConfigProps(contentStyle, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'marginBottom':
                    case 'marginLeft':
                    case 'marginRight':
                    case 'marginTop':
                        if (propValue && propUnit) {
                            if (!innerStyle) {
                                innerStyle = {};
                            }
                            innerStyle[propName.replace('margin', 'padding')] = `${propValue}${propUnit}`;
                        }
                        return true;
                }
            });
        }
        if (props.blockConfig.social) {
            content = props.blockConfig.social.map((d, i) =>
                <SocialPlatformComponent
                    key={`${d.platform}-${i}`}
                    blockConfig={d}
                    blockId={props.blockId}
                    builder={props.builder}
                    count={props.blockConfig.social.length}
                    frameDoc={props.frameDoc}
                    globalConfig={iconProps}
                    index={i}
                    renderMso={props.renderMso} />
            );
        }
    }
    return (
        <Wrapper {...props} className="mcnFollowBlock" style={wrapperStyle}>
            <td
                align="center"
                className="mcnFollowBlockInner"
                valign="top">
                <table
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="mcnFollowContentContainer"
                    style={{ minWidth: '100%' }}
                    width="100%">
                    <tbody>
                        <tr>
                            <td align="center">
                                <table
                                    border="0"
                                    cellPadding="0"
                                    cellSpacing="0"
                                    className="mcnFollowContent"
                                    style={{ minWidth: '100%' }}
                                    width="100%">
                                    <tbody>
                                        <tr>
                                            <td
                                                align="center"
                                                style={innerStyle}
                                                valign="top">
                                                <table
                                                    border="0"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    style={contentContainerStyle}>
                                                    <tbody>
                                                        <tr>
                                                            <td align={iconAlignment} style={contentStyle} valign="top">
                                                                {
                                                                    props.renderMso &&
                                                                    <Comment document={props.frameDoc} id={`${props.blockId}-inner-top`} value={`<!--[if mso]><table align="center" border="0" cellspacing="0" cellpadding="0" style="display:inline-table;"><tr><![endif]-->`} />
                                                                }
                                                                {content}
                                                                {
                                                                    props.renderMso &&
                                                                    <Comment document={props.frameDoc} id={`${props.blockId}-inner-bottom`} value={`<!--[if mso]></tr></table><![endif]-->`} />
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    )
}
const SocialTypeConfig = {
    panel: {
        block: function () {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color',
                        value: TypeConfig.defaultBackgroundColor
                    },
                    {
                        display: 'Content Background Color',
                        group,
                        name: 'contentColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'spacer-short'
                    },
                    {
                        display: 'Icon Properties',
                        group,
                        id: 'iconProps',
                        type: 'header'
                    },
                    {
                        display: 'Icon Style',
                        group,
                        name: 'iconStyle',
                        options: [
                            { display: 'Light', value: 'light' },
                            { display: 'Dark', value: 'dark' }
                        ],
                        type: 'dropdown',
                        value: 'light'
                    },
                    {
                        display: 'Icon Alignment',
                        group,
                        name: 'iconAlignment',
                        options: TypeConfig.options.alignment(),
                        type: 'dropdown',
                        value: 'center'
                    },
                    {
                        display: 'Icon Size',
                        fullWidth: true,
                        group,
                        max: '50',
                        name: 'iconSize',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider',
                        value: { value: '24', unit: 'px' }
                    },
                    {
                        display: 'Horizontal Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'horizontalSpacing',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider',
                        value: { value: '28', unit: 'px' }
                    },
                    {
                        display: 'Vertical Spacing',
                        fullWidth: true,
                        group,
                        max: '50',
                        name: 'verticalSpacing',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement-slider'
                    }
                ]
            }
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingLeft: { value: '27', unit: 'px' },
                            paddingRight: { value: '27', unit: 'px' },
                            paddingTop: { value: '18', unit: 'px' }
                        }
                    }
                ]
            };
        },
        social: function () {
            const group = 'social';
            const config = {
                dynamic: true,
                dynamicContent: {
                    display: 'Social Platform',
                    displayProperty: 'platform',
                    fullWidth: true,
                    group,
                    type: 'sortable',
                    options: [
                        {
                            display: 'Platform',
                            group,
                            name: 'platform',
                            options: [
                                { display: '1st Dibs', value: 'dibs' },
                                { display: 'ArtCloud', value: 'artcloud' },
                                { display: 'Artnet', value: 'artnet' },
                                { display: 'Artsy', value: 'artsy' },
                                { display: 'Bluesky', value: 'bluesky' },
                                { display: 'Facebook', value: 'facebook' },
                                { display: 'Houzz', value: 'houzz' },
                                { display: 'Instagram', value: 'instagram' },
                                { display: 'LinkedIn', value: 'linkedin' },
                                { display: 'Pinterest', value: 'pinterest' },
                                { display: 'TikTok', value: 'tiktok' },
                                { display: 'Twitter', value: 'twitter' },
                                { display: 'Vimeo', value: 'vimeo' },
                                { display: 'WhatsApp', value: 'whatsapp' },
                                { display: 'YouTube', value: 'youtube' },
                                { display: '- Spacer - ', value: 'spacer' }
                            ],
                            relatedProperties: [
                                'url'
                            ],
                            type: 'dropdown',
                            value: 'facebook'
                        },
                        {
                            default: {
                                'artcloud': 'https://artcloud.com/',
                                'artnet': 'http://www.artnet.com/',
                                'artsy': 'https://www.artsy.net/',
                                'bluesky': 'https://bsky.app/',
                                'dibs': 'https://www.1stdibs.com/',
                                'facebook': 'https://facebook.com/',
                                'houzz': 'https://www.houzz.com/',
                                'instagram': 'https://www.instagram.com/',
                                'linkedin': 'https://www.linkedin.com/',
                                'pinterest': 'https://www.pinterest.com/',
                                'spacer': undefined,
                                'tiktok': 'https://tiktok.com/',
                                'twitter': 'https://twitter.com/',
                                'vimeo': 'https://vimeo.com/',
                                'whatsapp': 'https://wa.me/',
                                'youtube': 'https://youtube.com/',
                            },
                            display: 'Social URL',
                            fullWidth: true,
                            group,
                            name: 'url',
                            relatedProperty: 'platform',
                            relatedPropertyOverridable: true,
                            type: 'text',
                            value: 'https://facebook.com/',
                            visible: (config) => config && config.platform != 'spacer'
                        },
                        {
                            fullWidth: true,
                            group,
                            type: 'spacer-short'
                        },
                        {
                            display: 'Icon Size',
                            fullWidth: true,
                            group,
                            max: '50',
                            name: 'iconSize',
                            options: TypeConfig.options.measurement(),
                            type: 'measurement-slider'
                        },
                        {
                            fullWidth: true,
                            group,
                            type: 'info',
                            value: '* Setting Icon Size will override the global configuration',
                        }
                    ]
                },
                group,
                label: 'Platforms',
                options: []
            };
            config.options.push({
                display: 'Add Social Platform',
                fullWidth: true,
                group,
                type: 'insert-button',
                value: config.dynamicContent
            });
            return config;
        },
    },

    parsing: {
        socialLinks: (links) => {
            const socialPlatforms = [];
            if (!links) {
                return socialPlatforms;
            }
            if (links.FacebookUrl) {
                socialPlatforms.push({
                    id: `social-facebook-${new Date().getTime()}`,
                    platform: "facebook",
                    url: links.FacebookUrl
                });
            }
            if (links.TwitterUrl) {
                socialPlatforms.push({
                    id: `social-twitter-${new Date().getTime()}`,
                    platform: "twitter",
                    url: links.TwitterUrl
                });
            }
            if (links.InstagramUrl) {
                socialPlatforms.push({
                    id: `social-instagram-${new Date().getTime()}`,
                    platform: "instagram",
                    url: links.InstagramUrl
                });
            }
            if (links.PinterestUrl) {
                socialPlatforms.push({
                    id: `social-pinterest-${new Date().getTime()}`,
                    platform: "pinterest",
                    url: links.PinterestUrl
                });
            }
            if (links.ArtsyUrl) {
                socialPlatforms.push({
                    id: `social-artsy-${new Date().getTime()}`,
                    platform: "artsy",
                    url: links.ArtsyUrl
                });
            }
            if (links.ArtnetUrl) {
                socialPlatforms.push({
                    id: `social-artnet-${new Date().getTime()}`,
                    platform: "artnet",
                    url: links.ArtnetUrl
                });
            }
            if (links.FirstDibsUrl) {
                socialPlatforms.push({
                    id: `social-dibs-${new Date().getTime()}`,
                    platform: "dibs",
                    url: links.FirstDibsUrl
                });
            }
            if (links.HouzzUrl) {
                socialPlatforms.push({
                    id: `social-houzz-${new Date().getTime()}`,
                    platform: "houzz",
                    url: links.HouzzUrl
                });
            }
            if (links.YouTubeUrl) {
                socialPlatforms.push({
                    id: `social-youtube-${new Date().getTime()}`,
                    platform: "youtube",
                    url: links.YouTubeUrl
                });
            }
            if (links.LinkedInUrl) {
                socialPlatforms.push({
                    id: `social-linkedin-${new Date().getTime()}`,
                    platform: "linkedin",
                    url: links.LinkedInUrl
                });
            }
            if (links.TikTokUrl) {
                socialPlatforms.push({
                    id: `social-tiktok-${new Date().getTime()}`,
                    platform: "tiktok",
                    url: links.TikTokUrl
                });
            }
            if (links.VimeoUrl) {
                socialPlatforms.push({
                    id: `social-vimeo-${new Date().getTime()}`,
                    platform: "vimeo",
                    url: links.VimeoUrl
                });
            }
            if (links.BlueskyUrl) {
                socialPlatforms.push({
                    id: `social-bluesky-${new Date().getTime()}`,
                    platform: "bluesky",
                    url: links.BlueskyUrl
                });
            }
            if (links.WhatsAppUrl) {
                socialPlatforms.push({
                    id: `social-whatsapp-${new Date().getTime()}`,
                    platform: "whatsapp",
                    url: links.WhatsAppUrl
                });
            }
            return socialPlatforms;
        }
    }
};
const SocialBlockTypeDefinition = (group, { links }) => {
    const socialPlatforms = SocialTypeConfig.parsing.socialLinks(links);
    return {
        id: Name.Block.Social,
        config: {
            block: SocialTypeConfig.panel.block(),
            social: SocialTypeConfig.panel.social(),
            layout: SocialTypeConfig.panel.layout(),
            defaults: [{ configName: "social", propertyValue: socialPlatforms }]
        },
        display: 'Social Links',
        group,
        image: 'social.svg',
    };
}
const Social = { BlockTypeDefinition: SocialBlockTypeDefinition, Component: SocialComponent, TypeConfig: SocialTypeConfig };

// region SOCIAL PLATFORM

function SocialPlatformComponent(props) {
    let alt, platform, url;
    let iconSize = '24';
    const contentStyle = { paddingTop: '3px' }; // Fudge factor for inline table display issue
    if (props.globalConfig) {
        if (props.globalConfig.iconSize && props.globalConfig.iconSize.value) {
            iconSize = props.globalConfig.iconSize.value;
        }
        if (props.globalConfig.verticalSpacing && props.globalConfig.verticalSpacing.value) {
            contentStyle.paddingBottom = `${props.globalConfig.verticalSpacing.value}${props.globalConfig.verticalSpacing.unit}`;
        }
        switch (props.globalConfig.iconAlignment) {
            case 'left':
                if (props.index != props.count - 1) {
                    contentStyle.paddingRight = props.globalConfig.paddingRight;
                }
                contentStyle.paddingLeft = props.globalConfig.paddingLeft;
                break;
            case 'right':
                if (props.index != 0) {
                    contentStyle.paddingLeft = props.globalConfig.paddingLeft;
                }
                contentStyle.paddingRight = props.globalConfig.paddingRight;
                break;
            default:
                contentStyle.paddingLeft = props.globalConfig.paddingLeft;
                contentStyle.paddingRight = props.globalConfig.paddingRight;
                break;
        }
    }
    if (props.blockConfig) {
        if (props.blockConfig.iconSize && props.blockConfig.iconSize.value && props.blockConfig.iconSize.value.length > 0) {
            iconSize = props.blockConfig.iconSize.value;
        }
        platform = props.blockConfig.platform;
        switch (platform) {
            case 'artcloud':
                alt = 'ArtCloud';
                break;
            case 'artnet':
                alt = 'Artnet';
                break;
            case 'artsy':
                alt = 'Artsy';
                break;
            case 'bluesky':
                alt = 'Bluesky';
                platform = 'bsky';
                break;
            case 'dibs':
                alt = '1st Dibs';
                platform = '1stdibs';
                break;
            case 'facebook':
                alt = 'Facebook';
                break;
            case 'houzz':
                alt = 'Houzz';
                break;
            case 'instagram':
                alt = 'Instagram';
                break;
            case 'linkedin':
                alt = 'LinkedIn';
                break;
            case 'pinterest':
                alt = 'Pinterest';
                break;
            case 'tiktok':
                alt = 'TikTok';
                break;
            case 'twitter':
                alt = 'Twitter';
                break;
            case 'vimeo':
                alt = 'Vimeo';
                break;
            case 'whatsapp':
                alt = 'WhatsApp';
                break;
            case 'youtube':
                alt = 'YouTube';
                break;
        }
        url = props.blockConfig.url;
    }
    let imageUrl = '';
    if (platform && platform != 'spacer') {
        imageUrl = `https://artcld-pub.s3.amazonaws.com/assets/campaign/icons/outline-${props.globalConfig && props.globalConfig.iconStyle || 'light'}-${platform}-48.png`;
    }
    return (
        <>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-${props.index}-top`} value={`<!--[if mso]><td align="center" valign="top"><![endif]-->`} />
            }
            <table
                align="center"
                border="0"
                cellPadding="0"
                cellSpacing="0"
                style={{ display: 'inline-table', fontSize: 0 }}>
                <tbody>
                    <tr>
                        <td
                            className="mcnFollowContentItemContainer"
                            style={contentStyle}
                            valign="top">
                            <table
                                border="0"
                                cellPadding="0"
                                cellSpacing="0"
                                className="mcnFollowContentItem"
                                width="100%">
                                <tbody>
                                    <tr>
                                        <td
                                            align="left"
                                            valign="middle">
                                            <table
                                                align="left"
                                                border="0"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                width="">
                                                <tbody>
                                                    <tr>

                                                        <td
                                                            align="center"
                                                            className="mcnFollowIconContent"
                                                            valign="middle"
                                                            width={iconSize}>
                                                            {
                                                                imageUrl &&
                                                                <a href={url} target="_blank">
                                                                    <img
                                                                        alt={alt || ''}
                                                                        className=""
                                                                        height={iconSize}
                                                                        src={imageUrl}
                                                                        style={{ display: 'block' }}
                                                                        width={iconSize} />
                                                                </a>
                                                            }
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
            {
                props.renderMso &&
                <Comment document={props.frameDoc} id={`${props.blockId}-${props.index}-bottom`} value={`<!--[if mso]></td><![endif]--></>`} />
            }
        </>
    )
}

export default Social;